let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6k2Y0")).then(() => parcelRequire('87h4V'));